import { render, staticRenderFns } from "./yhubReport.vue?vue&type=template&id=4be6e987&scoped=true"
import script from "./yhubReport.vue?vue&type=script&lang=js"
export * from "./yhubReport.vue?vue&type=script&lang=js"
import style0 from "./yhubReport.vue?vue&type=style&index=0&id=4be6e987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6e987",
  null
  
)

export default component.exports